
import React, { useState, useEffect } from "react";
import MuiButton from "Components/MuiButton/MuiButton";
import { Dialog, DialogActions, DialogContent } from "@material-ui/core";
import Translator from "Languages/Utility/Translator";
import Grid from "@material-ui/core/Grid";
import Input from "Components/Input/Input";
import { useSetState } from "Helpers/Hooks";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import showNotify from "Helpers/Notify";
import { setFactorSetting } from "Stores/actions";
import { useTheme } from '@material-ui/core/styles';

export default function FactorDescription ({disabled}) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const { factorSetting } = useSelector((state) => ({
    factorSetting: state.factor.factorSetting,
  }));
  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = useState(false);
  const [controls, setControls] = useSetState({
    invoiceDescription: {
      type: "text",
      value: "",
      validation: null,
    },
  });

  const handleDialog = () => setOpenDialog(!openDialog);

  const onEnter = () => {
    setControls({ invoiceDescription: { value: factorSetting?.Describ } });
  }

  const onShowDialog = () => {
    setOpenDialog(true);
  }

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
  };

  const handleSave = () => {
    const {invoiceDescription} = controls;
    const result = {
      ...factorSetting,
      Describ: invoiceDescription.value,
    };
    dispatch(setFactorSetting(result));

    showNotify({
      text: t('descriptionSavedSuccessfully'),
      customClass: "success",
    })
    setOpenDialog(false);
  }

  const onExit = () => {
    setOpenDialog(false);
  }

  return (
    <>
      <MuiButton
        color="secondary"
        title={<Translator id="invoiceDescription" />}
        onClick={onShowDialog}
        disabled={disabled}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        TransitionProps={{onEnter: onEnter, onExit: onExit}}
        onClose={handleDialog}
        fullWidth
        maxWidth="sm"
      >
        <form>
          <div className="dialogHeader mb-2">
            <p>
              <Translator id="saveInvoiceDescription" />
            </p>
          </div>
          <DialogContent>
            <Grid container spacing={2}>
              {Object.keys(controls).map((key, index) => {
                return (
                  <Grid item xs={12} key={key + index} >
                    {controls[key].type === "text" && (
                      <Input
                        setValue={setValue.bind(this)}
                        name={key}
                        validation={controls[key].validation}
                        placeholder={t('invoiceDescription')}
                        label={<Translator id={key} />}
                        type="text"
                        multiline={true}
                        value={controls[key].value}
                      />
                    )}
                  </Grid>
                )}
              )}
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
                color="primary"
                onClick={handleSave}
                title={<Translator id="button_save" />}
            />
            <MuiButton
                onClick={handleDialog}
                title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};